import * as React from 'react';
import { makeStyles, Typography, useMediaQuery } from '@material-ui/core';
import { CheckOutStateContext } from '../../providers/CheckOutStateContextProvider';
import { ElementDimensions } from '../../styles/ElementDimensions';

const useStyles = makeStyles({
    text: {
        textAlign: 'center',
    },
    link: {
        textAlign: 'center',
        color: '',
    },
    select: {
        width: '300px',
        height: '60px',
    },
    root: {
        height: '100vh',
        width: '100vw',
    },
    num: {
        width: '300px',
        height: '60px',
    },
});

const Test = () => {
    const classes = useStyles();
    const checkOutState = React.useContext(CheckOutStateContext);

    const getYearKeyValues = (): { key: string, value: string }[] => {
        let kvps: { key: string, value: string }[] = [];

        kvps.push({ key: "-1", value: "YYYY" })

        let date =  parseInt(new Date().getFullYear().toString());

        for (var i = 0; i <= 20; i++) {
            kvps.push({ key: (i + date).toString(), value: (i + date).toString()});
        }
        
        return kvps;
    }

    const getMonthYearKeyValues = (): { key: string, value: string }[] => {
        let kvps: { key: string, value: string }[] = [];
    
        kvps.push({ key: "-1", value: "MM/YYYY" })

        let date =  parseInt(new Date().getFullYear().toString());

        for (var i = 0; i <= 20; i++) {
            kvps.push({ key: (i + date).toString(), value: (i + date).toString()});

            for (var j = 1; j <= 12; j++) {
                if (j < 10) {
                    kvps.push({ key: "0" + j.toString() + "/" + (i + date).toString(), value: "0" + j.toString() + "/" + (i + date).toString()});
                }
                else {
                    kvps.push({ key: j.toString() + "/" + (i + date).toString(), value: j.toString() + "/" + (i + date).toString()});
                }
            }
        }
        
        
        return kvps;
    }

    return (
        <div className={classes.root}>
            <input className={classes.num} type="text"  id="cc-number" 
            name="cc-number" 
            autoComplete="cc-number" 
            x-autocompletetype="cc-number"></input>
            <br></br>
            <select className={classes.select}
            id="cc-exp-year" 
            name="cc-exp-year" 
            autoComplete="cc-exp-year" 
            x-autocompletetype="cc-exp-year">
                {
                    getYearKeyValues().map((kvp) => (
                        <option value={kvp.key}>{kvp.value}</option>
                    ))
                }
            </select>
            <select className={classes.select}
            id="cc-exp" 
            name="cc-exp" 
            autoComplete="cc-exp" 
            x-autocompletetype="cc-exp">
                {
                    getMonthYearKeyValues().map((kvp) => (
                        <option value={kvp.key}>{kvp.value}</option>
                    ))
                }
            </select>
        </div>
    );
};

export default Test;